import { ADD_CONTRIBUTOR, RESET_CONTRIBUTOR } from '../../types';
import {Contributor} from '../../../models/Contributor';

export const addContributor = (contributor: Contributor) => ({
  type: ADD_CONTRIBUTOR,
  contributor
});

export const resetContributor = () => ({
  type: RESET_CONTRIBUTOR,
});
